import styled from 'styled-components';
export const ParamDescriptorWrapper = styled.div.withConfig({
  displayName: "Helpers__ParamDescriptorWrapper",
  componentId: "sc-3o46l2-0"
})(["width:136px;"]);